import {
  type ChartQueryPanel,
  toQueryPanel,
} from 'features/charts-v2/types/chart-query-panel'
import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'
import { injectSemanticIntoPanel } from 'features/charts-v2/utils/inject-semantic-into-panel'

/**
 * A panel lowered to the wire fields a query route reads: the smart-search flag
 * written in as its `SEMANTIC` marker, then narrowed to the query fields. Order
 * matters (see `WireReadyPanel`); this is the one place that does it for a
 * caller with no request-specific rules of its own.
 */
export function buildRequestPanel(panel: ChartPanel): ChartQueryPanel {
  return toQueryPanel(injectSemanticIntoPanel(panel))
}
